<template>
  <div class="modal-box">
    <div class="modal edit-modal" @click.self="$emit('close-btn-click')">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ audience.name }}</h4>
          </div>
          <div class="modal-body">
            <template v-for="(eq, index) in event_questionnaires">
              <div v-if="audience.event_questionnaire_answers.length > index" class="form-group" :key="eq.id">
                <label class="form-label">{{ eq.introducer_text }}</label>
                <input type="text" id="modal-audience-introducer" class="form-control" :value="audience.event_questionnaire_answers[index].introducer" @change="updateIntroducersText($event, audience.event_questionnaire_answers[index].id)" />
              </div>
              <div v-else class="form-group" :key="eq.id">
                <label class="form-label">{{ eq.introducer_text }}</label>
                <input type="text" id="modal-audience-introducer" class="form-control" value="未回答" disabled/>
              </div>
            </template>
            <div class="form-group">
              <label class="form-label">電話番号</label>
              <input type="text" id="modal-audience-introducer_tell" class="form-control" :value="introducer_tell" @change="updateIntroducerTell" />
            </div>
            <div class="form-group">
              <label class="form-label">氏名</label>
              <input type="text" id="modal-audience-introducer_name" class="form-control" :value="introducer_name" @change="updateIntroducerName" />
            </div>
            <div class="form-group">
              <label class="form-label">住所</label>
              <input type="text" id="modal-audience-introducer_adress" class="form-control" :value="introducer_adress" @change="updateIntroducerAdress" />
            </div>
            <div class="form-group">
              <label class="form-label">備考</label>
              <textarea id="modal-audience-note" class="form-control" :value="note" @change="updateNote"></textarea>
            </div>
            <input type="hidden" id="modal-audience-id" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" @click="$emit('close-btn-click')">閉じる</button>
            <button type="button" class="btn btn-primary edit-modal-submit" @click="updateAudience(audience.id)">変更</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import Vue from 'vue';

export default {
  props: {
    audience: { type: Object, required: true },
    editAudienceIsSubAudience: { type: Boolean, required: true },
    event_questionnaires: { type: Array, required: true },
    edit_audience_path: { type: String, required: true },
    recapcha_api_key: { type: String, required: true },
  },
  created() {
    Vue.use(VueReCaptcha, {
      siteKey: this.recapcha_api_key,
      loaderOptions: {
        autoHideBadge: true,
      },
    });
    this.introducer_text_arr = this.audience.event_questionnaire_answers;
    this.introducer_tell = this.audience.introducer_tell;
    this.introducer_name = this.audience.introducer_name;
    this.introducer_adress = this.audience.introducer_adress;
    this.note = this.audience.note;
  },
  data() {
    return {
      introducer_text_arr: [],
      introducer_tell: '',
      introducer_name: '',
      introducer_adress: '',
      note: '',
    };
  },
  methods: {
    async updateAudience(id) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      await this.$recaptchaLoaded();
      const recapchaToken = await this.$recaptcha('login');
      const data = {
        audience: {
          event_questionnaire_answers_attributes: this.introducer_text_arr,
          introducer_tell: this.introducer_tell,
          introducer_name: this.introducer_name,
          introducer_adress: this.introducer_adress,
          note: this.note,
        },
        edit_audience_is_sub_audience: this.editAudienceIsSubAudience,
        recapchaToken: recapchaToken,
      };
      this.$store.dispatch('audience/updateAudience', { edit_audience_path: this.edit_audience_path, data: data, csrf_token: csrfToken, audience_id: id });
      this.$emit('close-btn-click');
    },
    updateIntroducersText(event, id) {
      const item = this.introducer_text_arr.find(data => data.id == id);
      if (item) {
        item.introducer = event.target.value;
      }else{
        this.introducer_text_arr.push({id: id, introducer: event.target.value});
      }
    },
    updateIntroducerTell(event) {
      this.introducer_tell = event.target.value;
    },
    updateIntroducerName(event) {
      this.introducer_name = event.target.value;
    },
    updateIntroducerAdress(event) {
      this.introducer_adress = event.target.value;
    },
    updateNote(event) {
      this.note = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
}

.edit-modal {
  display: flex;
  overflow-y: auto;

  .modal-title {
    font-size: 18px;
  }

  .modal-dialog {
    max-width: 100%;
    width: 700px;
    margin: auto;

    @media screen and (max-width: $break-point) {
      margin: auto 30px;
      height: 550px;
    }
  }

  .modal-body {
    padding: 15px;
    line-height: 1.5em;

    .form-group {
      padding-top: 10px;
      padding-bottom: 10px;

      .form-label {
        font-weight: 500;
        margin-bottom: 5px;
      }
    }
  }

  .modal-content {
    box-shadow: none;
    z-index: 9997;
  }

  .modal-footer {
    flex-direction: column;
    margin: auto;

    .btn-close {
      margin-top: 10px;
      border-radius: 4px;
      width: 100%;
      border: 1px solid $shop-lightgray;
      color: $shop-gray;
      margin-left: 0;
    }
  }
}
</style>
